import axios, { CostHeaderParamsType, createCostHeader } from '@/shared/axios';
import { CouponInfoModel } from '@/types/coupon';
import { BaseResponse } from '@/types/web.interface';
import {
  FollowBackModel,
  FollowStatusModel,
  HistoryOrderModel,
  MediaUserItem,
  RecordTaskModel,
  UnfollowRecordModel,
  UnfollowTrackingModel,
} from '@/types/unFollow';

export async function fetchCouponInfo() {
  const res = await axios.get<BaseResponse<CouponInfoModel>>(`/ins/monitor/item/coupon/info`);
  return res.data;
}

// unfollow
export async function fetchUnfollowData(searchName?: any, options?: CostHeaderParamsType) {
  const res = await axios.get<BaseResponse<MediaUserItem>>('/unfollow/search', {
    params: {
      searchName,
    },
    headers: createCostHeader(options),
  });
  return res.data;
}

export async function fetchRecordList() {
  const res = await axios.get<BaseResponse<[UnfollowRecordModel]>>('/unfollow/record');
  return res.data;
}
export async function fetchRecordDetail(recordId?: any, taskType?: string) {
  const res = await axios.get<BaseResponse<UnfollowRecordModel>>(
    `/unfollow/record/detail/${recordId}?task_type=${taskType}`
  );
  return res.data;
}

export async function fetchFollowBackDetail(unfollowUserId?: any, params?: any) {
  const res = await axios.get<BaseResponse<[FollowStatusModel]>>(`/unfollow/record/${unfollowUserId}/follow_back`, {
    params,
  });
  return res.data;
}

export async function fetchRecordTasksList(recordId?: any) {
  const res = await axios.get<BaseResponse<[RecordTaskModel]>>(`/unfollow/record/tasks/${recordId}`);
  return res.data;
}

export async function fetchTaskDetailList(taskId?: any, params?: any) {
  const res = await axios.get<BaseResponse<[FollowStatusModel]>>(`/unfollow/record/${taskId}/task_data`, {
    params,
  });
  return res.data;
}

export async function recordConnect(token: any, list: any) {
  const res = await axios.post<BaseResponse<any>>(`/unfollow/record/connect`, list, {
    headers: {
      Authorization: token,
    },
  });
  return res.data;
}

export async function fetchUnfollowTrackingList() {
  const res = await axios.get<BaseResponse<[UnfollowTrackingModel]>>('/unfollow/list/unfollow_tracking');
  return res.data;
}

export async function fetchFollowBackList() {
  const res = await axios.get<BaseResponse<[FollowBackModel]>>('/unfollow/list/follow_back');
  return res.data;
}
export async function fetchUnfollowListOrder() {
  const res = await axios.get<BaseResponse<[HistoryOrderModel]>>('/unfollow/list/order');
  return res.data;
}

export async function orderAddAccount(media_name: string, order_id: number, options: CostHeaderParamsType) {
  const res = await axios.post<BaseResponse<any>>(
    '/unfollow/order/add_user',
    { media_name, order_id },
    {
      headers: createCostHeader(options),
    }
  );
  return res.data;
}

//检查搜索是否跳转dashboard
export async function fetchSearchCheck(searchName: string) {
  const res = await axios.get<BaseResponse<boolean>>(`/unfollow/check?searchName=${searchName}`);
  return res.data;
}
